import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-1" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row row gx-2" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "upload-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = { class: "col-md-10" }
const _hoisted_11 = { class: "row gx-1" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = {
  class: "form-group mb-sm-2 mb-md-2",
  ref: "dropdownRef"
}
const _hoisted_18 = {
  key: 0,
  class: "dropdown-menu show"
}
const _hoisted_19 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Modifier un produit")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "produitForm",
        onSubmit: _ctx.editProduit,
        "validation-schema": _ctx.produitSchema,
        "initial-values": _ctx.produitForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Image Produit ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onChange: _cache[0] || (_cache[0] = (event) => _ctx.onFilePrinChange(event)),
                      accept: "image/jpeg, image/png, image/jpg",
                      hidden: ""
                    }, null, 544),
                    _createElementVNode("div", {
                      class: "preview-card",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                    }, [
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imagePreview,
                            alt: "Image preview"
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[12] || (_cache[12] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "icofont icofont-camera fs-1" })
                            ], -1),
                            _createTextVNode(" Cliquez pour ajouter l'image principal du produit ")
                          ]))),
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "delete-btn",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                          }, _cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Code du produit ", -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          modelValue: _ctx.codeProduit,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.codeProduit) = $event)),
                          name: "code",
                          class: "form-control shadow-none fs-md-15 text-black",
                          readonly: "true",
                          placeholder: "Ce code est généré"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "code",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Catégorie du produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "famille",
                          modelValue: _ctx.famille,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.famille) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.familleOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              onSelect: ($event: any) => (_ctx.selectFamille(field.value)),
                              placeholder: "Sélectionner la catégorie"
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "famille",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Nom du Produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nomProd",
                          type: "text",
                          modelValue: _ctx.prodName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prodName) = $event)),
                          onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showBox = true)),
                          class: "mb-2 form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le nom du produit"
                        }, null, 8, ["modelValue"]),
                        (_ctx.produitOptions.length > 0 && _ctx.showBox == true)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitOptions, (produit, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("a", _hoisted_19, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomProd",
                          class: "text-danger"
                        })
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Unité de Stockage ", -1)),
                        _createVNode(_component_Field, { name: "uniteStock" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.conditionnementOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Choisir l'unité de stockage" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "uniteStock",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Unité de gestion ", -1)),
                        _createVNode(_component_Field, { name: "uniteGestion" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.conditionnementgOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Choisir l'unité de gestion" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "uniteGestion",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Groupe de Taxe"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "groupe",
                          modelValue: _ctx.groupe,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.groupe) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.groupeOptions,
                              searchable: true,
                              "track-by": "value",
                              label: "label",
                              modelValue: _ctx.groupe,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.groupe) = $event))
                            }, field, {
                              placeholder: "Sélectionner un groupe",
                              onSelect: _ctx.onGroupeSelect
                            }), null, 16, ["options", "modelValue", "onSelect"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "groupe",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Mode de définition"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "mode",
                          modelValue: _ctx.mode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mode) = $event)),
                          readonly: _ctx.estRedonly
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, {
                              options: _ctx.modeOptions,
                              searchable: true,
                              "track-by": "value",
                              label: "label",
                              modelValue: _ctx.mode,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mode) = $event)),
                              disabled: _ctx.estRedonly,
                              placeholder: "Sélectionner le mode de definition",
                              onSelect: _cache[10] || (_cache[10] = (val) => { _ctx.mode = val })
                            }, null, 8, ["options", "modelValue", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "readonly"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "mode",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Description du produit ", -1)),
                _createVNode(_component_Field, {
                  name: "descProd",
                  as: "textarea",
                  placeholder: "Entrer la description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_30), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "descProd",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[24] || (_cache[24] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Modifier un produit ", -1)),
                _createVNode(_component_router_link, {
                  to: "/produits/liste-produits",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}